import { memo, useCallback } from "react";
import { Checkbox, Tooltip } from "@narmi/design_system";

import { useLocalization } from "@fluent/react";
import { useCurrentUser } from "../../../../../contexts/CurrentUserContext";

import styles from "./DeliveryMethod.module.scss";

interface DeliveryMethodProps {
  value: API.DeliveryChannel;
  onChange: (channel: API.DeliveryChannel) => void;
}

const DeliveryMethod = memo(({ value, onChange }: DeliveryMethodProps) => {
  const { l10n } = useLocalization();
  const { currentUser } = useCurrentUser();

  const hasSMS = value === "sms";
  const hasEmail = value === "email";
  const isSmsDisabled = !currentUser?.phone?.number;

  const handleChannelChange = useCallback(
    (channel: API.DeliveryChannel) => {
      if (channel === "sms" && isSmsDisabled) return;
      onChange(channel);
    },
    [value]
  );

  const emailOnChange = useCallback(() => {
    handleChannelChange("email");
  }, [handleChannelChange, hasEmail]);

  const smsOnChange = useCallback(() => {
    handleChannelChange("sms");
  }, [handleChannelChange, hasSMS]);

  const smsLabel = l10n.getString(
    "alerts-tooltip-label-sms-disabled",
    {},
    "Update your phone number in profile settings to receive SMS alerts."
  );

  return (
    <div className={styles.container}>
      <Checkbox label="Email" checked={hasEmail} onChange={emailOnChange} />
      {isSmsDisabled ? (
        <Tooltip text={smsLabel}>
          <Checkbox
            label="SMS"
            checked={hasSMS}
            onChange={smsOnChange}
            disabled={isSmsDisabled}
          />
        </Tooltip>
      ) : (
        <Checkbox
          label="SMS"
          checked={hasSMS}
          onChange={smsOnChange}
          disabled={isSmsDisabled}
        />
      )}
    </div>
  );
});

export default DeliveryMethod;
